import React from 'react';

export default (props) => (
  <div className="btn-clear"
       onClick={props.clearSelectedSounds}>
    CLEAR
  </div>
);



// WEBPACK FOOTER //
// ./frontend/components/controls/clear/clear.jsx